import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ContentPageList from './content_page_list';
import ContentPageDetail from './content_page_detail';

class ContentPage extends Component {
  componentDidMount(){
  }
  render() {
    //console.log(this.context);
    var params = this.context.router.route.match.params;
    var view;
    if(params.action===undefined){
      view = <ContentPageList/>;
    }else{
      if(params.id===undefined){
        view = <ContentPageDetail/>;
      }else{
        view = <ContentPageDetail action={params.action}/>;
      }
    }
    return (
      <div className="page-wrapper">{view}</div>
    );
  }
}

ContentPage.contextTypes = {
  router: PropTypes.object
};

export default ContentPage;
